export interface Project {
  id: number;
  title: string;
  description?: string;
  image?: string;
  img?: string;
  category?: string;
  isFeatured?: boolean;
  tag1?: string;
  tag2?: string;
  desc?: string;
}

const projects: Project[] = [
  {
    id: 1,
    title: "Hanging Bar",
    tag1: "Architecture",
    tag2: "Interior",
    desc: "A 40-foot-long hanging bar, fabricated for North Italia Restaurant. Designed for both function and aesthetic impact within a commercial dining space.",
    img: "/home/assets/img/projects/north-italia.jpg",
    isFeatured: true
  },
  {
    id: 2,
    title: "Pivot Gate",
    img: "/home/assets/img/projects/exterior-gate.jpg",
    tag1: "Architecture",
    tag2: "Exterior",
    desc: "Pivot gate with mid-century modern inspired metal panels. The gate rides on a bronze thrust washer with a custom stainless steel latching mechanism.",
    isFeatured: true
  },
  {
    id: 3,
    title: "Portable Sign",
    img: "/home/assets/img/projects/rollable-sign.jpg",
    tag1: "Products",
    tag2: "Exterior",
    desc: "Durable steel signage designed for portability and wind resistance. Fabricated for Brokers Hub Realty.",
    isFeatured: true
  },
  {
    id: 4,
    title: "Stairs and Railings",
    img: "/home/assets/img/projects/staircase.jpg",
    tag1: "Architecture",
    tag2: "Interior",
    desc: "Contemporary railings with stainless steel cables",
    isFeatured: true
  },
  {
    id: 5,
    img: "/home/assets/img/projects/hanging-bar2.jpg",
    tag1: "Architecture",
    title: "Hanging Bar",
    desc: "Fabricated for a golf course clubhouse, this hanging bar was designed for efficient shipping from Arizona to Texas and seamless on-site installation. Features include press-braked metal screen shelves and stainless steel wire rails. Installation and paint by Creative License International."
  },
  {
    id: 6,
    img: "/home/assets/img/projects/bridge.jpg",
    tag1: "Architecture",
    title: "Museum Display",
    desc: "A scaled replica of the historic Yuma Railroad Bridge, created for the Yuma County Children's Museum. Includes a custom stainless steel slide. Installation, paint, and woodwork by Nicomia."
  },
  {
    id: 7,
    img: "/home/assets/img/projects/planter-boxes.jpg",
    tag1: "Architecture",
    title: "Planter Boxes",
    desc: "Planter boxes featuring architectural stainless steel screens. Fabricated for the Prescott Valley Boys & Girls Club. Installation, paint, and woodwork by Nicomia."
  },
  {
    id: 8,
    img: "/home/assets/img/projects/butterfly-artwork.jpg",
    tag1: "Architecture",
    title: "Metal Artwork",
    desc: "Unique artwork created for Flower Child restaurant."
  },
  {
    id: 9,
    img: "/home/assets/img/projects/picture-artwork.jpg",
    tag1: "Products",
    title: "Hanging Picture Frame System",
    desc: "Custom fabricated for Prisma to support a flexible hanging art display. The track system was designed for clean aesthetics and easy installation in a St Louis area restaurant."
  },
  {
    id: 10,
    img: "/home/assets/img/projects/blanco-bar.jpg",
    tag1: "Architecture",
    title: "Hanging Bar",
    desc: "Fabricated to create a seamless, monolithic appearance. Each segment features an outer shell formed from a single piece of sheet metal, with an internal structure designed to accommodate integrated lighting and wiring. Paint and installation by Indwell."
  },
  {
    id: 11,
    img: "/home/assets/img/projects/antique-windows.jpg",
    tag1: "Architecture",
    title: "Antique Window Frames",
    desc: "Steel window frames fabricated to authentically replicate the original design of windows in a historic Downtown Phoenix warehouse."
  },
  {
    id: 12,
    img: "/home/assets/img/projects/planter4.jpg",
    tag1: "Architecture",
    title: "Steel Planters",
    desc: "Modern steel planters, gates, and screens made of rusted Corten steel for a private residence."
  }
];

export default projects;
